(ns net.kestec.mhda-pilgrimage.public.application.form.application-form-step2
  (:require
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/Grid" :default Grid]
    ["@mui/material/Chip" :default Chip]

    [net.kestec.mhda-pilgrimage.lib-ui.form-components :refer [grid-small grid-medium grid-full text-field date-field text-field-multi checkbox switch radio radio-group checkbox-group]]
    [net.kestec.mhda-pilgrimage.lib-ui.form-validator :refer [form-field-validator form-validator check-min-text-length check-not-nil check-date-is-future check-date-is-age
                                                              check-is-email check-is-phone]]
    [net.kestec.mhda-pilgrimage.db :as-alias db]
    [net.kestec.mhda-pilgrimage.public.application.application-events :as-alias application-events]
    [clojure.string :as str]
    [day8.re-frame.http-fx]
    [re-frame.core :as rf]
    ))


(def VALIDATOR
  {:shown_first_name {:check-fn (check-min-text-length 3) :error-text "Name mindestens 3 Zeichen" :missing-text "Namensschild Vorname"}
   :shown_last_name  {:check-fn (check-min-text-length 3) :error-text "mindestens 3 Zeichen" :missing-text "Namensschild Familienname"}
   :family_name      {:check-fn (check-min-text-length 1) :error-text "mindestens 1 Zeichen" :missing-text "Familienname"}
   :given_name       {:check-fn (check-min-text-length 1) :error-text "mindestens 1 Zeichen" :missing-text "Vorname"}

   :id_number        {:check-fn (check-min-text-length 5) :error-text "mindestens 5 Zeichen" :missing-text "Ausweisnummer"}
   :id_date          {:check-fn (check-date-is-age) :error-text "kein gültiges Datum" :missing-text "Ausweis Ausstellung"}
   :id_valid_until   {:check-fn (check-date-is-future) :error-text "kein gültiges zukünftiges Datum" :missing-text "Ausweis gültig bis"}

   :street_address   {:check-fn (check-min-text-length 5) :error-text "mindestens 5 Zeichen" :missing-text "Adresse"}
   :zip              {:check-fn (check-min-text-length 4) :error-text "mindestens 4 Zeichen" :missing-text "PLZ"}
   :city             {:check-fn (check-min-text-length 2) :error-text "mindestens 2 Zeichen" :missing-text "Ort"}

   :birthdate        {:check-fn (check-date-is-age) :error-text "mindestens 5 Zeichen" :missing-text "Geburtsdatum"}
   :birthtown        {:check-fn (check-min-text-length 2) :error-text "mindestens 2 Zeichen" :missing-text "Geburtsort"}

   :phone            {:check-fn (check-is-phone) :error-text "Telefonnummer mit Vorwahl +43664123456 mindestens 7 Zeichen" :missing-text "Telefonnummer"}
   :email            {:check-fn (check-is-email) :error-text "keine gültige Email aa@bb.cc" :missing-text "Email"}
   })



(defn main []
  (let [!application (rf/subscribe [::db/get ::db/selected-application])
        field-validator (form-field-validator VALIDATOR !application)
        form-valid (form-validator VALIDATOR !application)]
    [:> Grid {:container true}

     [grid-full [:> Typography {:variant "h3"} "2. Persönliche Daten"]]
     ;[grid-full [:pre (pr-str application)]]

     [grid-full [:> Typography {:variant "h5"} "Für das Namensschild"]]
     [grid-small
      [text-field {:label      "Rufname"
                   :value      (:shown_first_name @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :shown_first_name %])
                   :error      (:error (field-validator :shown_first_name))
                   :helperText (:helperText (field-validator :shown_first_name))
                   }]]
     [grid-small
      [text-field {:label      "Familienname"
                   :value      (:shown_last_name @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :shown_last_name %])
                   :error      (:error (field-validator :shown_last_name))
                   :helperText (:helperText (field-validator :shown_last_name))}]]

     [grid-full [:> Typography {:variant "h5"} "Name laut Reisedokument (Pass oder Personalausweis)"]]
     [grid-small
      [text-field {:label      "Vorname"
                   :value      (:given_name @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :given_name %])
                   :error      (:error (field-validator :given_name))
                   :helperText (:helperText (field-validator :given_name))}]]
     [grid-small
      [text-field {:label      "Familienname"
                   :value      (:family_name @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :family_name %])
                   :error      (:error (field-validator :family_name))
                   :helperText (:helperText (field-validator :family_name))}]]

     [grid-full]
     [grid-small
      [text-field {:label      "Ausweisnummer"
                   :value      (:id_number @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :id_number %])
                   :error      (:error (field-validator :id_number))
                   :helperText (:helperText (field-validator :id_number))}]]
     [grid-small
      [date-field {:label      "Ausweis Austellungsdatum"
                   :value      (when (> (count (:id_date @!application)) 9) (subs (:id_date @!application) 0 10))
                   :onChange   #(rf/dispatch [::application-events/store-value :id_date %])
                   :error      (:error (field-validator :id_date))
                   :helperText (:helperText (field-validator :id_date))}]]
     [grid-small
      [date-field {:label      "Ausweis gültig bis"
                   :value      (when (> (count (:id_valid_until @!application)) 9) (subs (:id_valid_until @!application) 0 10))
                   :onChange   #(rf/dispatch [::application-events/store-value :id_valid_until %])
                   :error      (:error (field-validator :id_valid_until))
                   :helperText (:helperText (field-validator :id_valid_until))}]]




     [grid-full [:> Typography {:variant "h5"} "Adresse"]]
     [grid-full
      [text-field {:label      "Straße/Hausnummer/Top"
                   :value      (:street_address @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :street_address %])
                   :error      (:error (field-validator :street_address))
                   :helperText (:helperText (field-validator :street_address))}]]
     [grid-small
      [text-field {:label      "Postleitzahl"
                   :value      (:zip @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :zip %])
                   :error      (:error (field-validator :zip))
                   :helperText (:helperText (field-validator :zip))}]]
     [grid-small
      [text-field {:label      "Ort"
                   :value      (:city @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :city %])
                   :error      (:error (field-validator :city))
                   :helperText (:helperText (field-validator :city))}]]


     [grid-full [:> Typography {:variant "h5"} "Weitere Daten"]]
     [grid-small
      [date-field {:label      "Geburtsdatum"
                   :value      (when (> (count (:birthdate @!application)) 9) (subs (:birthdate @!application) 0 10))
                   :onChange   #(rf/dispatch [::application-events/store-value :birthdate %])
                   :error      (:error (field-validator :birthdate))
                   :helperText (:helperText (field-validator :birthdate))}]]
     [grid-small
      [text-field {:label      "Geburtsort"
                   :value      (:birthtown @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :birthtown %])
                   :error      (:error (field-validator :birthtown))
                   :helperText (:helperText (field-validator :birthtown))}]]
     [grid-full]
     [grid-small
      [text-field {:label      "Telefonnummer"
                   :value      (:phone @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :phone (str/replace % #" " "" )])
                   :error      (:error (field-validator :phone))
                   :helperText (:helperText (field-validator :phone))}]]
     [grid-small
      [text-field {:label      "Email"
                   :value      (:email @!application)
                   :onChange   #(rf/dispatch [::application-events/store-value :email (str/trim %)])
                   :error      (:error (field-validator :email))
                   :helperText (:helperText (field-validator :email))}]]


     [grid-full
      ;[:pre (pr-str form-valid)]
      (when-not (:valid form-valid)
        (into [:<> "Es fehlen noch folgende Eingaben: "]
              (for [missing (:formMissingText form-valid)]
                [:> Chip {:label (str missing) :sx {:backgroundColor "var(--color-mhda-red)" :color "var(--color-mhda-red-text)"}}])
              ))
      ]

     ]

    )
  )